import { defineStore } from 'pinia'

import { actions } from './actions'
import { createInitialState } from './state'
import { getters } from './getters'

export const useBookingStore = defineStore('booking', {
  state: createInitialState,
  actions,
  getters,
})
